module.exports = __webpack_public_path__ + "img/330426.11305a07.png";